"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _styles.makeStyles)(() => ({
  root: {
    alignItems: "center",
    flexDirection: "row"
  }
}));
const Checkbox = props => {
  const {
    name,
    label,
    required = false,
    addition,
    checked = false,
    value
  } = props;
  const [isChecked, setIsChecked] = _react.default.useState(checked);
  const css = useStyles();
  const handleChange = e => {
    setIsChecked(e.target.checked);
  };
  const toggleChange = e => {
    setIsChecked(!isChecked);
  };
  if (!name) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    fullWidth: true,
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, _extends({}, props, {
      checked: isChecked,
      value: value,
      onChange: handleChange,
      required: required,
      name: name
    })),
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  }), /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    component: "span",
    onClick: toggleChange,
    dangerouslySetInnerHTML: {
      __html: addition
    }
  }));
};
var _default = exports.default = Checkbox;